function Users() {
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true">
      <circle cx="17" cy="16" r="7" />
      <circle cx="31" cy="18" r="6" />
      <path d="M5 38c0-7 5-11 12-11s12 4 12 11" />
      <path d="M29 29c7 0 12 3 14 9" />
    </svg>
  );
}

export default Users;
